import QuickstartShouldRenderWithProjectContext from './ui/render-controller/index.tsx';

export const JswQuickStartShouldRender = QuickstartShouldRenderWithProjectContext;
